import { useState } from "react";
import { useNavigate } from "react-router";
import { MODELS, MUTATIONS, useModel, useMutation } from "../../../../../api";
import { ROUTES } from "../../../../../routes.js";
import Dialog from "../../../../../design-system/components/Dialog/Dialog.jsx";
import tokens from "../../../../../design-system/tokens.js";
import { getConfirmAbortButtons } from "../../../../../design-system/components/Confirm/ConfirmAbortButtons.jsx";
import styles from "./WorkshopDeleteButton.css.ts";

function WorkshopDeleteButton({ workshop }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const me = useModel(MODELS.ME);
  const [doDeleteWorkshop] = useMutation(MUTATIONS.deleteWorkshop);

  if (!me) return null;

  // Only admins or workshop owners can delete a workshop
  if (!me.isAdmin && workshop.owner && workshop.owner.id !== me.id) return null;

  function handleConfirm() {
    setOpen(false);

    doDeleteWorkshop({
      id: workshop.id,
    }).then(() => {
      navigate(ROUTES.lernreisenOverview.getUrl());
    });
  }

  function handleOpen() {
    setOpen(true);
  }

  return (
    <>
      <button className={styles.workshopDeleteButton} onClick={handleOpen}>
        Lernreise löschen
      </button>

      <Dialog
        open={open}
        setOpen={setOpen}
        title={"Lernreise löschen?"}
        buttons={getConfirmAbortButtons(setOpen, handleConfirm, "Löschen")}
      >
        <p
          style={{
            color: tokens.color.full.red,
          }}
        >
          Wenn du die Lernreise löschst, gehen alle darin gespeicherten
          Informationen verloren.
        </p>
      </Dialog>
    </>
  );
}

export default WorkshopDeleteButton;
